"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSalesOrderDetailsForCurrentTime = void 0;
const react_1 = require("react");
/**
 * Helper hook to determine selection state of an ingredient in a product build
 */
const useSalesOrderDetailsForCurrentTime = (salesOrderItemBuilt, blueprintStockedProduct) => {
    const { selectedProducts, productBlueprint: { blueprintStockedProductMinMaxQuantities, productAvailabilityMap } } = salesOrderItemBuilt;
    const { productId } = blueprintStockedProduct;
    const availability = (0, react_1.useMemo)(() => productAvailabilityMap.get(productId), [
        productAvailabilityMap,
        productId
    ]);
    const selectedProduct = selectedProducts.find(sp => sp.product.productId === productId);
    const quantity = selectedProduct === undefined ? 0 : selectedProduct.quantity;
    const isSelected = quantity > 0;
    const { canAdd, canRemove } = availability;
    const quantitySelected = salesOrderItemBuilt.quantitySelectedForProductBasedOnCategory(blueprintStockedProduct);
    const { min, max } = blueprintStockedProductMinMaxQuantities.get(productId);
    // states of ingredient
    const removable = isSelected && canRemove && quantitySelected < 2 && min === 0;
    const addable = (canAdd && !isSelected) || (quantitySelected >= max && !isSelected);
    return (0, react_1.useMemo)(() => ({
        removable,
        addable
    }), [removable, addable]);
};
exports.useSalesOrderDetailsForCurrentTime = useSalesOrderDetailsForCurrentTime;
//# sourceMappingURL=useBlueprintStockedProductSelectionState.js.map